// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_v84","cls2":"Unibrow-cls2_R66 Unibrow-cls1_v84"};